import { useEffect, useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { useUser } from '@/contexts/UserContext';

/**
 * Muestra el entorno de la AEAT al que se enviarán los registros.
 *
 * El destino lo decide el servidor a partir de la configuración VeriFactu del
 * usuario; aquí solo se refleja, para que enviar no sea una sorpresa.
 */
export function EntornoAEATBadge() {
  const { fetchWithAuth } = useUser();
  const [entorno, setEntorno] = useState<'pruebas' | 'produccion' | null>(null);

  useEffect(() => {
    let activo = true;

    fetchWithAuth('/verifactu/config')
      .then(res => (res.ok ? res.json() : null))
      .then(config => {
        if (activo && config?.entornoAEAT) setEntorno(config.entornoAEAT);
      })
      .catch(() => {
        // El badge es informativo: si la config no carga, no se muestra nada.
      });

    return () => { activo = false; };
  }, [fetchWithAuth]);

  if (!entorno) return null;

  const esProduccion = entorno === 'produccion';

  return (
    <Badge
      variant={esProduccion ? 'default' : 'secondary'}
      className={esProduccion ? 'bg-green-600 hover:bg-green-700' : ''}
      title="Entorno configurado en VeriFactu para los envíos a la AEAT"
    >
      {`AEAT: ${esProduccion ? 'Producción' : 'Pruebas'}`}
    </Badge>
  );
}
